<template>
  <HeaderLayout />
  <div class="consultFormContainer">
    <h2 class="consultFormTitle">免費諮詢</h2>
    <ConsultForm />
  </div>
  <div class="footer">
    <iframe
      id="pez_ft"
      width="100%"
      scrolling="No"
      height="150"
      frameborder="0"
      marginheight="0"
      marginwidth="0"
      src="//www.payeasy.com.tw/_iframe/ft.shtml"
    ></iframe>
  </div>
</template>

<script>
import ConsultForm from "../components/ConsultForm.vue";
import HeaderLayout from "../components/HeaderLayout.vue";
export default {
  name: "FormWithHeaderAndFooter",
  components: { ConsultForm, HeaderLayout },
};
</script>

<style>
.consultFormContainer {
  margin: 100px 0 20px;
}
.consultFormTitle {
  padding: 0 15px;
}
.footer {
  width: 100%;
}
</style>
